import axios from 'axios';
import { User } from '../../components/client-panel/components/my-account-info/models/user.model';
import { UserSelection } from '../../components/client-panel/components/my-account-info/models/user-selection.model';

export const getIfUserExistance = (email: string) => {
    return axios.get<boolean>(`user/checkIfExistByEmail/${email}`);
};

export const getCurrentUser = () => {
    return axios.get<User>(`user/getCurrentUser`);
};

export const getUserRecentSelection = () => {
    return axios.get<UserSelection>(`user/GetUserRecentSelection`);
};

export const updateUserRecentSelection = (userSelection: UserSelection) => {
    return axios.post<UserSelection>(`user/UpdateUserRecentSelection`, userSelection);
};
